<h1 mat-dialog-title>
  <div class="flex flex-row items-center">
    <div
      class="flex flex-row items-center mx-2 justify-center bg-accent-900 rounded-full h-10 w-10"
    >
      <mat-icon class="icon-size-5" color="primary" svgIcon="mat_outline:help"></mat-icon>
    </div>
    <span class="text-primary">{{ data.title | transloco }}</span>
  </div>
</h1>
<mat-divider></mat-divider>

<h4 class="my-2">
  {{ data.subtitle | transloco }}
</h4>

<div mat-dialog-content class="overflow-hidden max-h-max">
  <div class="flex flex-col my-4 gap-5 align-center overflow-hidden">
    <ol class="list-decimal list-inside flex flex-col gap-4 ps-3 text-secondary">
      <li *ngFor="let bullet of data.bullets">
        <span *ngIf="bullet.property">
          <b *ngIf="bullet.property">{{ bullet.property | transloco }}</b
          ><br /></span
        >{{ bullet.value | transloco }}
        <br />
        <div *ngIf="bullet?.icon" class="flex flex-row justify-center">
          <div
            class="flex flex-row justify-center max-w-fit my-6 p-4 bg-accent-900 rounded-md items-center"
          >
            <mat-icon class="icon-size-8" [svgIcon]="bullet?.icon" color="primary"></mat-icon>
          </div>
        </div>
      </li>
    </ol>
    <div *ngIf="data?.image" class="flex flex-row justify-center w-full items-center">
      <img class="flex flex-row p-4 rounded-md bg-accent-900 w-full" [src]="data.image" />
    </div>
  </div>
</div>

<div class="flex flex-row justify-end gap-2 items-center mt-2">
  <button mat-raised-button color="primary" class="mat-dense" (click)="onAccept()">
    {{ 'Ok' | transloco }}
  </button>
</div>
